import React from 'react';
import { Container, Typography, Grid, Card, CardContent, Button, Box } from '@mui/material';
import { TipsAndUpdates, ArrowBack, TrendingUp, Timeline } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const StudentInsights: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Button startIcon={<ArrowBack />} onClick={() => navigate('/student-dashboard')} sx={{ mb: 3 }}>
                Back to Dashboard
            </Button>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
                <TipsAndUpdates sx={{ fontSize: 40, color: '#FDCB6E' }} />
                <Typography variant="h4" fontWeight="bold">Intel & Insights</Typography>
            </Box>

            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <Card sx={{ bgcolor: '#E8F6F6', borderRadius: 4, border: 'none', boxShadow: 0, height: '100%', p: 2 }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                <TrendingUp sx={{ color: '#00B894' }} />
                                <Typography variant="subtitle2" fontWeight="bold" color="#00B894">UPCOMING SKILL</Typography>
                            </Box>
                            <Typography variant="h5" fontWeight="bold" gutterBottom>Data Analysis</Typography>
                            <Typography variant="body1" color="text.secondary" paragraph>
                                Currently learning Algebra II, which unlocks Data Science basics next semester.
                            </Typography>
                            <Button variant="text" color="primary">View Learning Path</Button>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card sx={{ bgcolor: '#FFF0F0', borderRadius: 4, border: 'none', boxShadow: 0, height: '100%', p: 2 }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                <Timeline sx={{ color: '#FF7675' }} />
                                <Typography variant="subtitle2" fontWeight="bold" color="#FF7675">NEXT MILESTONE</Typography>
                            </Box>
                            <Typography variant="h5" fontWeight="bold" gutterBottom>Mid-Term Prep</Typography>
                            <Typography variant="body1" color="text.secondary" paragraph>
                                Completing 3 more modules ensures you are 100% covered for the exam.
                            </Typography>
                            <Button variant="text" color="error">View Study Guide</Button>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Card sx={{ bgcolor: '#F0F3FF', borderRadius: 4, border: 'none', boxShadow: 0, height: '100%', p: 2 }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                <TipsAndUpdates sx={{ color: '#6C5CE7' }} />
                                <Typography variant="subtitle2" fontWeight="bold" color="#6C5CE7">CAREER PATH</Typography>
                            </Box>
                            <Typography variant="h5" fontWeight="bold" gutterBottom>Engineering</Typography>
                            <Typography variant="body1" color="text.secondary" paragraph>
                                Your consistent performance in Physics strongly aligns with Engineering tracks.
                            </Typography>
                            <Button variant="text" color="secondary">Explore Careers</Button>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
};

export default StudentInsights;
